import angular from 'angular';

module.exports = angular.module('common.filters.assignee-photo', [
  require('../models/assignee'),
])
.filter('assigneePhoto', function(Assignee) {
  return function(human) {
    var id = (typeof(human) === 'object' && human) ? human.id : human;
    return (Assignee[id] || Assignee[null]).image;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/assignee-photo.js
 **/